<template>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-briefcase"></i>
      {{ $t('entrepreneur.title') }}
      <createButton name="entrepreneurs_create" :title="$t('entrepreneur.create.title')"></createButton>
    </div>
    <div class="card-body">
      <errorMessage v-bind:message="error"></errorMessage>

      <div class="table-responsive">
        <table
          class="table table-bordered table-striped"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th class="export">{{ $t('entrepreneur.form.number') }}</th>
              <th>{{ $t('entrepreneur.form.familyName') }}</th>
              <th>{{ $t('entrepreneur.form.name') }}</th>
              <th width="230">{{ $t('entrepreneur.form.phone') }}</th>
              <th class="export">{{ $t('entrepreneur.form.cellphone') }}</th>
              <th class="export">{{ $t('entrepreneur.form.officePhone') }}</th>

              <th>{{ $t('entrepreneur.form.email') }}</th>

              <th>{{ $t('entrepreneur.form.company.title') }}</th>
              <th class="export">{{ $t('member.form.birthdate') }}</th>
              <th class="export">{{ $t('entrepreneur.form.sex') }}</th>
              <th class="export">{{ $t('entrepreneur.form.immigrant') }}</th>
              <th class="export">{{ $t('entrepreneur.form.immigrantCountry') }}</th>
              <th class="export">{{ $t('entrepreneur.form.language') }}</th>
              <th class="export">{{ $t('entrepreneur.form.education') }}</th>
              <th class="export">{{ $t('entrepreneur.form.numberEnterpriseAsManager') }}</th>
              <th class="export">{{ $t('address.title') }}</th>

              <th class="export">{{ $t('social.socialNetworks') }}</th>

              <th class="export">{{ $t('entrepreneur.form.social.infolettre') }}</th>
              <th class="export">{{ $t('social.followFacebook') }}</th>
              <th class="export">{{ $t('social.followLinkedinGroup') }}</th>
              <th class="export">{{ $t('social.followLinkedinProfile') }}</th>

              <th class="no-sort no-filter" v-if="canCreate || canDelete">&nbsp;</th>
              <th class="no-sort no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th class="export">{{ $t('entrepreneur.form.number') }}</th>
              <th>{{ $t('entrepreneur.form.familyName') }}</th>
              <th>{{ $t('entrepreneur.form.name') }}</th>
              <th width="230">{{ $t('entrepreneur.form.phone') }}</th>
              <th class="export">{{ $t('entrepreneur.form.cellphone') }}</th>
              <th class="export">{{ $t('entrepreneur.form.officePhone') }}</th>

              <th>{{ $t('entrepreneur.form.email') }}</th>

              <th>{{ $t('entrepreneur.form.company.title') }}</th>
              <th class="export">{{ $t('member.form.birthdate') }}</th>
              <th class="export">{{ $t('entrepreneur.form.sex') }}</th>
              <th class="export">{{ $t('entrepreneur.form.immigrant') }}</th>
              <th class="export">{{ $t('entrepreneur.form.immigrantCountry') }}</th>
              <th class="export">{{ $t('entrepreneur.form.language') }}</th>
              <th class="export">{{ $t('entrepreneur.form.education') }}</th>
              <th class="export">{{ $t('entrepreneur.form.numberEnterpriseAsManager') }}</th>
              <th class="export">{{ $t('address.title') }}</th>

              <th class="export">{{ $t('social.socialNetworks') }}</th>

              <th class="export">{{ $t('entrepreneur.form.social.infolettre') }}</th>
              <th class="export">{{ $t('social.followFacebook') }}</th>
              <th class="export">{{ $t('social.followLinkedinGroup') }}</th>
              <th class="export">{{ $t('social.followLinkedinProfile') }}</th>

              <th class="no-sort no-filter" v-if="canCreate || canDelete">&nbsp;</th>
              <th class="no-sort no-filter" v-if="canCreate || canDelete">&nbsp;</th>
            </tr>
          </tfoot>
          <tbody>
            <tr
              v-for="entrepreneur in entites"
              :key="entrepreneur.id"
              v-bind:data-id="entrepreneur.id"
              @click="view(entrepreneur.id)"
              class="clickable-row"
            >
              <td>{{entrepreneur.id}}</td>
              <td>{{entrepreneur.familyName}}</td>
              <td>{{entrepreneur.name}}</td>
              <td>
                <i class="fa fa-fw fa-mobile" aria-hidden="true"></i>
                {{entrepreneur.cellphone}}
              </td>
              <td>
                <i class="fa fa-fw fa-home" aria-hidden="true"></i>
                {{entrepreneur.phone}}
              </td>
              <td>
                <i class="fa fa-fw fa-building" aria-hidden="true"></i>
                {{entrepreneur.officePhone}}
                <span
                  v-if="entrepreneur.officePhoneExtension"
                >#</span>
                {{entrepreneur.officePhoneExtension}}
              </td>
              <td>{{entrepreneur.email}}</td>
              <td>
                <span
                  class="company"
                  v-for="item in filterCompany(entrepreneur.companyEntrepreneur)"
                  :key="item.id"
                >{{item.name }}</span>
              </td>

              <td>{{ entrepreneur.birthdate | formatDate }}</td>
              <td>{{ entrepreneur.sexText }}</td>
              <td>{{ entrepreneur.immigrant | formatBoolean }}</td>
              <td>{{ entrepreneur.immigrantCountry }}</td>
              <td>{{ entrepreneur.language }}</td>
              <td>{{ entrepreneur.educationText }}</td>
              <td>{{ entrepreneur.numberEnterpriseAsManager }}</td>

              <td>{{ entrepreneur.address | addressFormat }}</td>

              <td>{{ entrepreneur.social != null ? entrepreneur.social.socialNetworks : '' }}</td>

              <td>{{ entrepreneur.infolettre | formatBoolean }}</td>
              <td>{{ entrepreneur.social != null ? entrepreneur.social.followFacebook : null | formatBoolean }}</td>
              <td>{{ entrepreneur.social != null ? entrepreneur.social.followLinkedinGroup: null | formatBoolean }}</td>
              <td>{{ entrepreneur.social != null ? entrepreneur.social.followLinkedinProfile: null | formatBoolean }}</td>

              <td class="no-sort" align="center" v-if="canCreate || canDelete">
                <a
                  href="#"
                  v-if="canCreate"
                  v-bind:title="$t('form.edit_button')"
                  v-on:click.stop="edit(entrepreneur.id)"
                >
                  <span class="fa fa-lg fa-pencil"></span>
                </a>
                &nbsp;
                <a
                  href="#"
                  v-if="canCreate"
                  v-bind:title="$t('form.copy_button')"
                  v-on:click.stop="copy(entrepreneur.id)"
                >
                  <span class="fa fa-lg fa-copy"></span>
                </a>
                &nbsp;
                <a
                  class="text-danger"
                  v-if="canDelete"
                  v-bind:title="$t('form.delete_button')"
                  href="#"
                  v-on:click.stop="deleteEntity(entrepreneur.id)"
                >
                  <span class="fa fa-lg fa-trash"></span>
                </a>
              </td>
              <td v-if="canCreate || canDelete">
                <span v-if="entrepreneur.associatedUserId != null">
                  <strong>Accès intranet existant</strong>
                </span>
{{test(entrepreneur)}}
                <button
                  class="btn btn-success"
                  v-if="entrepreneur.associatedUserId == null"
                  v-on:click.stop="createEntrepreneurUser(entrepreneur)"
                >{{ $t('entrepreneur.action.createEntrepreneurUser') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {EntrepreneurServiceClient, UserServiceClient, CreateUserDto} from '../../shared/service-clients/service-clients'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'Entrepreneurs',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: EntrepreneurServiceClient,
      userServiceClient: UserServiceClient,
      datatableOptions: {
        aaSorting: [[1, 'asc'], [2, 'asc']],
        sort: [[1, 'asc'], [2, 'asc']],
      },
    }
  },
  methods: {
    filterCompany: function(companyEntrepreneur) {
      return _.chain(companyEntrepreneur)
        .groupBy(x => x.company.id)
        .map((value, key) => ({name: value[0].company.entreprise.name}))
        .value()
    },
    test: function(entrepreneur) {},
    createEntrepreneurUser: function(entrepreneur) {
      var input = new CreateUserDto()
      input.firstName = entrepreneur.name
      input.lastName = entrepreneur.familyName
      input.emailAddress = entrepreneur.email
      input.roleNames = ['Entrepreneur']
      input.phoneNumber = entrepreneur.phone
      input.forIntranet = true
      input.entityType = 'Entrepreneur'
      input.entityId = entrepreneur.id
      var self = this
      swal({
        title: 'Êtes-vous sûr?',
        text: 'Cette action va créer les accès intranet de ' + input.emailAddress + ' !',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willSend => {
        if (willSend) {
          let userServiceClient = ServiceFactory.create(UserServiceClient)
          userServiceClient
            .create(input)
            .then(res => {
              entrepreneur.associatedUserId = res.id
              swal('Envoyé avec succès!', {
                icon: 'success',
              })
            })
            .catch(err => {
              var friendlyMessage = self.$t(`errors.duplicateUserName`)
              swal({
                title: 'Une erreur est survenu!',
                text: friendlyMessage,
                icon: 'error',
              })
              console.log(this.getErrorMessage(err))
            })
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.company ~ .company::before {
  content: ", ";
}
</style>




// WEBPACK FOOTER //
// src/components/entrepreneur/Entrepreneurs.vue